export class DefibrillatorUpdatedData {
    id: string;
    type: string;
    updatedProperties: DefibrillatorProperty[];

    constructor(id: string) {
      if (id === undefined || id === null) {
        throw new Error('ID is required.');
      }
      this.id = id;
      this.type = 'Defibrillator';
      this.updatedProperties = [];
    }
}

export class DefibrillatorProperty {
    type: string = 'Property';
    value: any;
    field: string;

    constructor(field: string, value: any) {
      this.field = field;
      this.value = value;
    }
}
